import React, {Component} from 'react'
import {connect} from "react-redux";
import {MDBCol, MDBContainer, MDBRow} from "mdbreact";
import ArticleList from "../Component/ArticleList/ArticleList";
import HotPostList from "../Layout/HotPostList/HotPostList";

class Hot extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol size={12}>
                        <HotPostList/>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        );
    }
}


const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)


export default enhance(Hot)